import { openBlock as a, createElementBlock as z, createElementVNode as l } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function m(t, h) {
  return a(), z("svg", e, [...h[0] || (h[0] = [
    l("mask", {
      id: "a",
      fill: "#fff"
    }, [
      l("path", { d: "M17 3a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-.791c-2.1 2.857-5.475 3.867-7.209 4 2.486-.746 2.911-2.43 2.838-4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z" })
    ], -1),
    l("path", {
      fill: "currentColor",
      d: "M21 7h1zm-4 10v1zm-.791 0v-1h-.506l-.3.408zM9 21l-.287-.958.364 1.955zm2.838-4 .999-.047-.045-.953h-.954zM3 13H2zM7 3V2zm10 0v1a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm4 4h-1v6h2V7zm0 6h-1a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-4 4v-1h-.791v2H17zm-.791 0-.806-.592c-1.875 2.55-4.935 3.476-6.48 3.595L9 21l.077.997c1.922-.148 5.613-1.242 7.938-4.405zM9 21l.287.958c1.44-.432 2.4-1.179 2.959-2.151.542-.944.632-1.977.59-2.854l-.998.047-.999.047c.032.692-.054 1.287-.328 1.764-.257.449-.753.918-1.798 1.231zm2.838-4v-1H7v2h4.838zM7 17v-1a3 3 0 0 1-3-3H2a5 5 0 0 0 5 5zm-4-4h1V7H2v6zm0-6h1a3 3 0 0 1 3-3V2a5 5 0 0 0-5 5zm4-4v1h10V2H7z",
      mask: "url(#a)"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M15.607 11.04h1.008l.43.554c.27-.317.422-.793.422-1.422 0-1.211-.57-1.867-1.446-1.867-.875 0-1.453.656-1.453 1.867s.578 1.867 1.453 1.867q.17-.001.328-.031zm3.055-.868c0 1.008-.344 1.785-.899 2.273l.805 1.024h-1.101l-.454-.57a2.7 2.7 0 0 1-.992.18c-1.508 0-2.648-1.071-2.648-2.907 0-1.844 1.14-2.906 2.648-2.906 1.492 0 2.64 1.062 2.64 2.906M9.58 13H8.316l1.961-5.656h1.508L13.737 13H12.48l-.421-1.305H10.01zm.727-2.219h1.454l-.711-2.164h-.04zM5.477 13V7.344h3.726v.968H6.648v1.376h2.313v.968H6.648V13z"
    }, null, -1)
  ])]);
}
const v = { render: m };
export {
  v as default,
  m as render
};
